import { useContext, useEffect, useState } from "react";
import RecipeContext from "./store/recipe-context";
import * as uuid from "uuid";
import Button from "./Button";

import css from "./Export.module.css";
import Section from "./section";

function Export() {
  const recipeContext = useContext(RecipeContext);

  const saveTemplateAsFile = (filename, data) => {
    const blob = new Blob([data], {
      type: "text/json",
    });

    const link = document.createElement("a");

    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    link.dataset.downloadurl = ["text/json", link.download, link.href].join(
      ":"
    );

    const evt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    link.dispatchEvent(evt);
    link.remove();
  };

  function recipeObject() {
    return {
      name: recipeContext.name,
      ingredients: recipeContext.ingredients.map((ingredient) => {
        return (
          ingredient.amount + " " + ingredient.unit + " " + ingredient.name
        );
      }),
      miseEnPlace: recipeContext.miseEnPlace.map(
        (miseEnPlace) => miseEnPlace.item
      ),
      method: recipeContext.method.map((method) => method.item),
      notes: recipeContext.notes.map((note) => note.item),
    };
  }

  const headers = Object.freeze({
    ingredients: "Ingredients",
    miseEnPlace: "Mise En Place",
    method: "Method",
    notes: "Notes",
  });

  function createStringSection(array, header) {
    var brake = "\n\n";

    if (array.length > 0) {
      console.log(array);
      return "Mise En Place\n" + array.join(brake) + brake;
    } else {
      return "";
    }
  }

  function createtxtFile() {
    const recipe = recipeObject();
    var fileName = recipe.name + ".txt";
    var brake = "\n\n";

    let data =
      recipe.name +
      brake +
      "Ingredients\n" +
      recipe.ingredients.join("\n") +
      brake;

    data = data.concat(
      createStringSection(recipe.miseEnPlace, headers.miseEnPlace)
    );
    data = data.concat(createStringSection(recipe.method, headers.method));
    data = data.concat(createStringSection(recipe.notes, headers.notes));

    saveTemplateAsFile(fileName, data);
  }

  function createRecipeFile() {
    const recipe = {
      name: recipeContext.name,
      ingredients: recipeContext.ingredients.map((ingredient) => {
        return (
          ingredient.amount + " " + ingredient.unit + " " + ingredient.name
        );
      }),
      miseEnPlace: recipeContext.miseEnPlace.map(
        (miseEnPlace) => miseEnPlace.item
      ),
      method: recipeContext.method.map((method) => method.item),
      notes: recipeContext.notes.map((note) => note.item),
    };
    var fileName = recipe.name + ".recipe";
    saveTemplateAsFile(fileName, JSON.stringify(recipe, null, 4));
  }
  const fileTypes = [".recipe", ".txt", "both"];
  const [fileType, setFileType] = useState(fileTypes[0]);

  const handleChange = (event) => {
    setFileType(event.target.value);
  };

  const [buttonTapped, setButtonTapped] = useState(false);

  function checkForRecipeName() {
    setButtonTapped(!buttonTapped);
    recipeContext.updateMissingParts(recipeContext.name);
  }

  useEffect(() => {
    if (buttonTapped && !recipeContext.missingParts) {
      crateFile();
      setButtonTapped(false);
    }
    if (buttonTapped) {
      setButtonTapped(false);
    }
  });

  function crateFile() {
    if (fileType === fileTypes[0]) {
      createRecipeFile();
    } else if (fileType === fileTypes[1]) {
      createtxtFile();
    } else if (fileType === fileTypes[2]) {
      createtxtFile();
      createRecipeFile();
    }
  }

  return (
    <Section sectionStyle="spaceBetween" column={true}>
      <h1 className={css.h1}>Download File</h1>
      <div className={css.selectContainer}>
        <p className={css.p}>Select file type:</p>
        <select
          id="selectDownloadType"
          value={fileType}
          onChange={handleChange}
          className={css.select}
        >
          {fileTypes.map((type) => (
            <option key={uuid.v4()} value={type}>
              {type}
            </option>
          ))}
        </select>
        <Button onClick={checkForRecipeName}>
          {recipeContext.name}
          {fileType === fileTypes[2] ? " " + fileType + " " : fileType + " "}
          Download
        </Button>
      </div>
    </Section>
  );
}

export default Export;
